"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _constants = require("./constants");

var _tracking = require("settings-ui-app/utils/tracking");

var _AsyncContainers = require("./AsyncContainers");

var _default = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRouter.Route, {
  path: "" + _constants.ROUTE,
  component: _AsyncContainers.AsyncAnalyticsAndTrackingContainer
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: "tracking"
}), _react.default.createElement(_reactRouter.Route, {
  path: "tracking",
  component: _AsyncContainers.AsyncTrackingPage,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('tracking')
}), _react.default.createElement(_reactRouter.Route, {
  path: "domains",
  component: _AsyncContainers.AsyncDomainsAndIPPage,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('domains')
}), _react.default.createElement(_reactRouter.Route, {
  path: "analytics-views",
  component: _AsyncContainers.AsyncAnalyticsViewsPage,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('analytics-views')
}), _react.default.createElement(_reactRouter.Route, {
  path: "cookies",
  component: _AsyncContainers.AsyncCookiePolicyPage,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('cookies')
})), _react.default.createElement(_reactRouter.Route, {
  path: "events-javascript",
  component: _AsyncContainers.AsyncCustomJSPage,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('custom-js')
}));

exports.default = _default;
module.exports = exports.default;